import {
	Stack,
	type StackProps,
	Typography,
	type TypographyProps,
	useTheme,
} from "@mui/material";
import type { FC } from "react";
import { getInitials } from "web_myplann/Shared/Utils/getInitials";

type Props = Omit<StackProps, "children"> & {
	background?: string;
	initialsColor?: string;
	name: string;
	photo?: string;
	size?: number;
	muted?: boolean;
	initialsVariant?: TypographyProps["variant"];
};

export const InitialsAvatar: FC<Props> = ({
	background,
	initialsColor,
	name,
	photo,
	size = 80,
	muted,
	initialsVariant,
	sx,
	...stackProps
}) => {
	const theme = useTheme();

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			{...stackProps}
			sx={[
				{
					width: size,
					height: size,
					borderRadius: "50%",
					overflow: "hidden",
					...(background
						? { background }
						: {
								bgcolor: muted
									? theme.palette.grey[100]
									: theme.palette.blue[100],
							}),
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
		>
			{photo ? (
				<img
					src={photo}
					alt={name}
					width={size}
					height={size}
					style={{ objectFit: "cover" }}
				/>
			) : (
				<Typography
					variant={initialsVariant}
					color={
						initialsColor ??
						(muted ? theme.palette.grey[600] : theme.palette.blue[700])
					}
					fontSize={initialsVariant ? undefined : size * 0.3}
					fontWeight={initialsVariant ? undefined : 700}
					lineHeight={1}
				>
					{getInitials(name)}
				</Typography>
			)}
		</Stack>
	);
};
